// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zwH-","col":"styles_col__2XCwl"};